import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class ModalHelperService {
  constructor(private translateService: TranslateService) {}

  public confirm(title: string, content: string, executeOnOk?: () => void, executeOnCancel?: () => void): void {
    const dialog = DialogUtility.confirm({
      title: this.translateService.instant(title),
      content: this.translateService.instant(content),
      okButton: {
        text: this.translateService.instant('i18n.shared.ok'),
        click: () => {
          if (executeOnOk) {
            executeOnOk();
          }
          dialog.close();
        },
      },
      cancelButton: {
        text: this.translateService.instant('i18n.shared.cancel'),
        click: () => {
          if (executeOnCancel) {
            executeOnCancel();
          }
          dialog.close();
        },
      },
      showCloseIcon: true,
      closeOnEscape: true,
    });
  }
}
